module.exports = "/_next/static/images/DeliveryCentrifuge@2x-0ea60721d6ca6675d569a284e2305625.webp";